// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as Translation$LumiI18n from "lumi-i18n/lib/es6/src/Translation.res.js";

let options = [
  "OnePlace",
  "TwoPlaces"
];

let jsonCodec = LumiJzon.anySumAsString(options, undefined);

function translate(locale, entry) {
  switch (locale) {
    case "ENG" :
      if (entry === "OnePlace") {
        return "One place";
      } else {
        return "Two places";
      }
    case "NLD" :
      if (entry === "OnePlace") {
        return "Één plaats";
      } else {
        return "Twee plaatsen";
      }
    default:
      return;
  }
}

let T = Translation$LumiI18n.MakeProvider({
  defaultLocale: "ENG",
  translate: translate
});

export {
  options,
  jsonCodec,
  T,
}
/* jsonCodec Not a pure module */
